import React, { useState, useEffect } from "react";
import styled, { css, keyframes } from "styled-components";
import currencies from "../../../lib/currencies/currencies";

import { ReactComponent as SettingsSvg } from "../../../svg/settings.svg";

import useSound from "use-sound";

import forwardSound from "../../../audio/goForward.mp3";
const animSVG = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    transform: scale(1);
  }
  50%{
    animation-timing-function: cubic-bezier(0, 0, 0, 1);
    transform: scale(.65);
  }
  100%{
    transform: scale(1);
  }
`;

const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 315px;
  width: 315px;
  margin: 0 auto;

  #menu {
    animation: ${(p) =>
    p.animSG &&
    css`
        ${animSVG} 333ms 1 forwards
      `};
  }
  span {
    svg {
      margin-left: 5px;
      height: 28px;
    }
  }
  h1 {
    font-size: 26px;
    color: #ffb100;
  }
`;
export const BalanceContainer = styled.div`
    color: #32075b;
    font-size: 12px;
    max-width: 159px;
    width: 100%;
    text-align: right;
    position: relative;
    margin-left: 5px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: flex-end;
    flex-wrap: wrap;
    `
export const Balance = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
`

export const Header = ({
  betInfo,
  currency,
  handleAbove,
  gameMode,
  toFix,
  sound,
  volume,
}) => {
  const [balanceHead, setbalanceHead] = useState(betInfo.balance);
  const [animSG, setanimSG] = useState(false);
  const [forwardSFX] = useSound(forwardSound, { volume });

  useEffect(() => {
    setbalanceHead(betInfo.balance-betInfo.winAmount);
    switch (gameMode) {
      case "sonic":
        setTimeout(() => {
          setbalanceHead(betInfo.balance);
        }, 300);
        break;
      case "40":
        setTimeout(() => {
          setbalanceHead(betInfo.balance);
        }, 4800);
        break;
      case "80":
        setTimeout(() => {
          setbalanceHead(betInfo.balance);
        }, 8800);
        break;
      default:
        break;
    }
  }, [betInfo, gameMode]);

  return (
    <HeaderDiv animSG={animSG} data-testid="HeaderDiv">
      <h1>keno</h1>
      <BalanceContainer>
       <span style={{ textTransform:'none' }}>
        {currencies[currency]}
      </span>
      <Balance>{(balanceHead && balanceHead.toFixed(toFix)) || "0.00"}</Balance>
       </BalanceContainer>
      <SettingsSvg
        id="menu"
        style={{ cursor: "pointer" }}
        onClick={() => {
          setanimSG(true);
          if (sound) forwardSFX();
          handleAbove("settings");
          setTimeout(() => {
            setanimSG(false);
          }, 400);
        }}
      />
    </HeaderDiv>
  );
};
